import { VectroResourceType } from '@/resources/resource-types';
import type { DocumentNode } from 'graphql';

export interface ResourceListQueryDefinition {
	document: DocumentNode;
	dataPath?: string;
	totalPath?: string;
	variables?: Record<string, unknown>;
}

export interface ResourceViewQueryDefinition {
	document: DocumentNode;
	dataPath?: string;
	variables?: Record<string, unknown>;
}

export interface ResourceMutationDefinition {
	document: DocumentNode;
	operation?: string;
	getVariables?: (
		variables: Record<string, unknown>
	) => Record<string, unknown>;
	transformResponse?: (response: unknown) => unknown;
}

export const listResourceQueryDefinitions: Partial<
	Record<VectroResourceType, ResourceListQueryDefinition>
> = {};

export const viewResourceQueryDefinitions: Partial<
	Record<VectroResourceType, ResourceViewQueryDefinition>
> = {};

export const createResourceMutationDefinitions: Partial<
	Record<VectroResourceType, ResourceMutationDefinition>
> = {};

import {
	PRICING_POLICY_CREATE_MUTATION,
	PRICING_POLICY_UPDATE_MUTATION
} from '@/pages/pricing-policies/pricing-policy-update.gql';

createResourceMutationDefinitions['pricingPolicies'] = {
	document: PRICING_POLICY_CREATE_MUTATION,
	operation: 'createPricingPolicy',
	getVariables: variables => ({ input: variables })
};

export const updateResourceMutationDefinitions: Partial<
	Record<VectroResourceType, ResourceMutationDefinition>
> = {
	pricingPolicies: {
		document: PRICING_POLICY_UPDATE_MUTATION,
		operation: 'updatePricingPolicy',
		getVariables: variables => ({ input: variables })
	}
};

export const deleteResourceMutationDefinitions: Partial<
	Record<VectroResourceType, ResourceMutationDefinition>
> = {};
